import { inject } from '@angular/core';
import type { CanActivateFn } from '@angular/router';

import { Store } from '@ngrx/store';
import type { Observable } from 'rxjs';
import { of } from 'rxjs';
import { catchError, filter, switchMap } from 'rxjs/operators';
import { AuthService } from '../../core/auth/auth.service';
import { selectFlagsmithFeatureFlagsLoaded } from '../../store';

/* This guard checks:
     1. Is the user is authenticated
     2. Waits until Flagsmith feature flags are loaded into the store
        - Flagsmith feature flags are fetched by the flagsmith-feature-flag.effects.ts constructor
*/
export const flagsmithFeatureFlagsGuard: CanActivateFn = (): Observable<boolean> => {
  const authService = inject(AuthService);
  const store = inject(Store);

  return authService.isAuthenticated$.pipe(
    filter((isAuthenticated) => isAuthenticated),
    switchMap(() => {
      return store.select(selectFlagsmithFeatureFlagsLoaded).pipe(filter((loaded) => loaded));
    }),
    catchError(() => of(false))
  );
};
